import React from "react";
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <p>© 2026 Srijana Shrestha. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
